exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-dropdown .dropdown-menu{min-width:auto;padding:2px}.invoice-dropdown .dropdown-menu.show{display:inherit}.mw-52{min-width:52px}", ""]);

// exports
